module.exports = __webpack_public_path__ + "img/card-recomandations.b45106a3.svg";